export const instanceIdStorageKey = 'ignite.configUi.instanceId';
export const activeInstanceIdStorageKey = 'ignite.configUi.activeInstanceId';
